import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { enforceOrganizerTrackingResidency } from '../services/organizerTracking';
import isCheckoutRoutePathname from '../services/isCheckoutRoutePathname';
import readTrackedEventKeyFromPathname from '../services/readTrackedEventKeyFromPathname';

function OrganizerTrackingResidencyGuard() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (isCheckoutRoutePathname(pathname)) {
            return;
        }
        enforceOrganizerTrackingResidency(readTrackedEventKeyFromPathname(pathname));
    }, [pathname]);

    return null;
}

export default OrganizerTrackingResidencyGuard;
